import { render, staticRenderFns } from "./ReachCard.vue?vue&type=template&id=2005d24c&scoped=true&"
import script from "./ReachCard.vue?vue&type=script&lang=js&"
export * from "./ReachCard.vue?vue&type=script&lang=js&"
import style0 from "./ReachCard.vue?vue&type=style&index=0&id=2005d24c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005d24c",
  null
  
)

export default component.exports